import authApi from '@/api/auth'
import userApi from '@/api/user'

const state = {
  authenticated: false,
  user: {
    email: '',
    avatar: ''
  }
}

const getters = {
  authenticated (state) {
    return state.authenticated
  },
  user (state) {
    return state.user
  }
}

const mutations = {
  SET_AUTHENTICATED (state, authenticated) {
    state.authenticated = authenticated
  },
  SET_USER (state, user) {
    state.user = user
  },
  SET_USER_AVATAR (state, avatar) {
    state.user.avatar = avatar
  },
  CLEAR (state) {
    state.authenticated = false
    state.user = {
      email: '',
      avatar: ''
    }
  }
}

const actions = {
  async login ({ commit, state }, { email, password }) {
    const user = await authApi.login({ email, password })
    commit('SET_AUTHENTICATED', true)
    commit('SET_USER', user)
  },
  async logout ({ commit }) {
    await authApi.logout()
    commit('CLEAR')
  },
  async check ({ commit }) {
    const checkResult = await authApi.check()
    if (checkResult.authenticated) {
      commit('SET_AUTHENTICATED', true)
      commit('SET_USER', checkResult.user)
      return true
    }
    return false
  },
  async updateAvatar ({ commit }, formData) {
    const result = await userApi.updateAvatar(formData)
    commit('SET_USER_AVATAR', result.avatar)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
